<template>
		<template v-if="!showVendors"> 
			<vendor-filter @show-vendors="showMap" :site-key="siteKey" :only-mag="mag" :last-mag="lastMag" :last-zip="lastZip"></vendor-filter>
		</template>
		<template v-else>
			<vendor-map @reset-filter="resetFilter" :vendors="vendors"></vendor-map>
		</template>		
</template>

<script setup lang="ts">
	import { ref } from 'vue';
	import VendorFilter from './VendorFilter.vue';
	import VendorMap from './VendorMap.vue';
	
	const props = defineProps({
		mag: String,
		siteKey: String
	});
	
	const showVendors = ref(false);
	const vendors = ref([]);
	const lastMag = ref("");
	const lastZip = ref("");

	function showMap(emittedVendors: object[], mag: string, zip: string) {
		showVendors.value=true;
		vendors.value=emittedVendors;
		lastZip.value=zip;
		lastMag.value=mag;
	}
	
	function resetFilter(): void {
		lastMag.value='';
		lastZip.value='';
		showVendors.value=false; 
	}
</script>